/**
 * SneakyInput component
 *
 * Meant to not look like "standard" inputs, but "ordinary text"
 *
 * Optional props:
 * width : string - width of input box (with unit)
 * title : boolean - if input is considered as "editable" title of page
 *
 * Examples of component:
 * <SneakyInput width="100px" placeholder="100 pixels wide input" />
 * <SneakyInput title placeholder="Title input" />
 *
 */

import styled from 'styled-components';
import React from 'react';
import { InputMessage } from '../';

const SneakyInput = styled.input`
	border: 0;
	padding: 10px 0;
	outline: 0;
	background: transparent;
	width: ${props => props.width || '100%'};

	font-size: ${props => {
		if (props.title) return '32px';
	}};
`;

const SneakyInputComponent = props => {
	const { className, input, ...rest } = props;

	const meta = props.meta || {};
	const submitFailed = meta.submitFailed || false;
	const error = meta.error || false;

	return (
		<div className={className}>
			<SneakyInput {...rest} {...input} />

			{submitFailed && error && <InputMessage>{error}</InputMessage>}
		</div>
	);
};

export default SneakyInputComponent;



// WEBPACK FOOTER //
// ./src/components/Common/SneakyInput/SneakyInput.js